import type { COMMUNITY_ID } from '~/entities/container/community/interfaces/community'

export default {
  Media: {
    Swym: {
      Content: '/api/media/listallmedia',
      // Even API names with '/communities/', it can be used for getting medias in RTConversation (and Community)
      ContentV2: (subjectUri: string) => `/api/v2/communities/${subjectUri}/media`,
      Duplicate: '/api/media/duplicate',
    },
    Exalead: {
      Content: '/api/exalead/search',
    },
  },
  Post: {
    Exalead: {
      Count: '/api/exalead/searchstats',
      Content: '/api/exalead/whatsnew',
    },
    Swym: {
      Content: '/api/feed/whatsnew',
      ContentV2: (communityUri: COMMUNITY_ID) => `/api/v2/communities/${communityUri}/posts`,
    },
  },
  Conference: {
    Swym: {
      Content: '/api/feed/whatsnew',
    },
    Exalead: {
      Content: '/api/exalead/whatsnew',
    },
  },
  Survey: {
    Swym: {
      Content: '/api/feed/whatsnew',
    },
    Exalead: {
      Content: '/api/exalead/whatsnew',
    },
  },
  Question: {
    Exalead: {
      Count: '/api/exalead/searchstats',
      Content: '/api/exalead/whatsnew',
    },
    Swym: {
      Content: '/api/feed/whatsnew',
    },
  },
  Wiki: {
    Swym: {
      Content: '/api/feed/whatsnew',
    },
    Exalead: {
      Content: '/api/exalead/whatsnew',
    },
  },
  Wedo: {
    Exalead: {
      Count: '/api/exalead/searchstats',
      Content: '/api/exalead/whatsnew',
    },
    Swym: {
      Content: '/api/feed/whatsnew',
    },
  },
  Idea: {
    Exalead: {
      Count: '/api/exalead/searchstats',
      Content: '/api/exalead/whatsnew',
    },
    Swym: {
      Content: '/api/feed/whatsnew',
      ContentV2: (communityUri: COMMUNITY_ID) => `/api/v2/communities/${communityUri}/ideas`,
      Statuses: (communityUri: COMMUNITY_ID) => `/api/v2/communities/${communityUri}/ideas/statuses`,
    },
  },
  Draft: {
    Exalead: {
      Count: '/api/exalead/searchstats',
      Content: '/api/exalead/search',
    },
    Swym: {
      Content: '/api/v2/user/contributions',
    },
  },
  MeActivity: {
    Exalead: {
      Count: '/api/exalead/searchstats',
      Content: '/api/exalead/search',
    },
    Swym: {
      Content: '/api/v2/user/activity',
    },
  },
  Contribution: {
    Exalead: {
      Count: '/api/exalead/searchstats',
      Content: '/api/exalead/search',
    },
    Swym: {
      Content: '/api/v2/user/contributions',
    },
  },
  Network: {
    Swym: {
      Content: '/api/network/getnetworkactivity',
    },
  },
  ContentReader: {
    Exalead: {
      Count: '/api/exalead/searchstats',
      Content: '/api/exalead/search',
    },
  },
  Rituals: {
    Exalead: {
      Content: '/api/exalead/whatsnew',
    },
  },
}

// interface ICrudApi {
//   get: () => string
//   delete: () => string
//   patch: () => string
//   post: () => string
// }

// Keep commented for now because is not used anywhere but can but useful in a near future
// export const CONTENT_APIS: Record<IContentModel, ICrudApi> = {
//   [IContentModel.Post]: {
//     get: () => '/api/post/get_instance',
//     delete: () => '/api/community/deletecontribution',
//     patch: () => '/api/post/updatepost',
//     post: () => '/api/post/addpost',
//   },
//   [IContentModel.Media]: {
//     get: () => '/api/media/getmedia',
//     delete: () => '/api/community/deletecontribution',
//     patch: () => '',
//     post: () => '/api/post/addpost',
//   },
//   [IContentModel.Idea]: {
//     get: () => '/api/Ideation/get',
//     delete: () => '/api/community/deletecontribution',
//     patch: () => '/api/Ideation/update',
//     post: () => '/api/Ideation/add',
//   },
//   [IContentModel.Question]: {
//     get: () => '/api/IquestionsQuestions/getquestioninfos',
//     delete: () => '/api/community/deletecontribution',
//     patch: () => '/api/IquestionsQuestions/update',
//     post: () => '/api/IquestionsQuestions/add',
//   },
//   [IContentModel.Wiki]: {
//     get: () => '/api/WikiTree/get_instance',
//     delete: () => '/api/WikiTree/delete',
//     patch: () => '/api/WikiTree/update',
//     post: () => 'api/WikiTree/addChild',
//   },
//   [IContentModel.Conference]: {
//     get: ({ subject_uri } = { subject_uri: '' }) => `/api/conferences/${subject_uri}`,
//     delete: ({ subject_uri } = { subject_uri: '' }) => `/api/conferences/${subject_uri}`,
//     patch: ({ subject_uri } = { subject_uri: '' }) => `/api/conferences/${subject_uri}`,
//     post: ({ community_uri } = { community_uri: '' }) => `/api/communities/${community_uri}/conferences`,
//   },
//   [IContentModel.Wedo]: {
//     get: () => '/wedoproxy/send',
//     delete: () => '/wedoproxy/send',
//     patch: () => '/wedoproxy/send',
//     post: () => '/wedoproxy/send',
//   },
//   [IContentModel.Survey]: {
//     get: () => '/api/poll/updatepoll',
//     delete: () => '/api/community/deletecontribution',
//     patch: () => '/api/poll/updatepoll',
//     post: () => '/api/poll/createpoll',
//   },
// }
